// extracted by mini-css-extract-plugin
export default {"companyContainer":"JO-z","companyImage":"KO-z","container":"LO-z","heading":"MO-z","darkText":"NO-z","smallHeading":"OO-z","darkBackground":"PO-z","whiteBackground":"QO-z"};